module.exports = __webpack_public_path__ + "img/code1.631eb7ea.png";